<sl-count-display [label]="label" [amount]="amount" [decimalPlaces]="2" symbol="%" />
